<template>
    <!-- * 内容区域 -->
    <div class="vpm-input container">
        <!-- 顶部模块 -->
        <section class="vpm-header">
            <div class="vpm-title title-2 font-bold">{{ $t("MousePhenoPredict") }}</div>
            <div class="vpm-controls">
                <div class="vpm-control">
                    <div class="control-label">{{ $t("Layout.TypeName", { type: "Gene", count: 0 }) }}</div>
                    <div class="control-main">
                        <DefaultSearch
                            v-model="data.name"
                            :width="264"
                            mode="select"
                            type="gene"
                            :query="{ tax_names: ['Mouse'] }"
                            @search="methods.change" />
                    </div>
                </div>

                <div class="vpm-control">
                    <div class="control-label">{{ $t("TranscriptID") }}</div>
                    <div class="control-main">
                        <UiSelect
                            v-model="data.transcript"
                            :candidates="mrnas"
                            :readonly="mrnas.length == 0"
                            :placeholder="$t('Placeholder.FilterBy')"
                            @change="methods.mrna" />
                    </div>
                </div>
            </div>
        </section>

        <!-- 预览模块 -->
        <section class="vpm-main">
            <!-- 预览可视化模型 -->
            <PreviewModel ref="preview" />

            <!-- 数据粘贴模块 -->
            <div class="vpm-paste">
                <UiInput v-model="data.paste" class="paste-input" :width="264" :placeholder="$t('EnterMutation')" @change="methods.mutation" />
                <UiTooltip theme="dark" class="paste-levitate">
                    <template #default><UiIcon name="question-mark" class="paste-icon" /></template>
                    <template #content>
                        <ul>
                            <li style="font-weight: 700">{{ $t("ExampleData", 2) }}:</li>
                            <li>1、g.12G>C</li>
                            <li>2、c.123G>A</li>
                            <li>3、c.123_124TG>C</li>
                            <li>4、c.169+2T>C</li>
                            <li>5、c.45_46insGC</li>
                            <li>6、c.36_38del</li>
                            <li>7、c.45_48delinsTT</li>
                            <li>8、c.-1G>T</li>
                            <li>9、c.*16G>T</li>
                            <li>10、c.23+4_23+5GG>CT</li>
                            <li>11、p.A3F(GCT>TTT)</li>
                            <li>12、p.R75X</li>
                            <li>13、IVS2+1</li>
                        </ul>
                    </template>
                </UiTooltip>
            </div>

            <div class="vpm-components">
                <!-- 单选按钮组 -->
                <UiRadioGroup class="vpm-radios" v-model="data.mode" @change="methods.mode">
                    <UiRadio value="Gene">{{ $t("Gene") }}</UiRadio>
                    <UiRadio value="Transcript">{{ $t("Transcript") }}</UiRadio>
                    <UiRadio value="Protein">{{ $t("Protein") }}</UiRadio>
                </UiRadioGroup>

                <!-- 模型组 -->
                <component ref="model" class="vpm-model" :is="view" @redraw="(data: any) => preview.drawPos(data)"></component>
            </div>
        </section>

        <section class="vpm-footer">
            <UiButton @click="methods.submit" size="middle">{{ $t("Prediction") }}</UiButton>
        </section>
    </div>

    <!-- * 确认窗口 -->
    <confirm-modal ref="confirm" @confirm="(data) => utils.submit(data)" :content="$t('PredictionMutationDELConfirm')" />
</template>

<script lang="ts" setup>
//* 组件库
import { UiRadioGroup, UiSelect, UiButton, UiRadio, UiInput, UiIcon, UiTooltip } from "various-ui";
//* 公共组件
import { DefaultSearch } from "@/components/controls";
import { ConfirmModal } from "@/components/windows";
//* 私有组件
import PreviewModel from "./components/preview/index.vue";
//* 组件属性
import { useComposable } from "./src/composable";

//* 插件
const route = useRoute();

//* 组合函数
const { data, refs, nodes, utils, methods, computeds } = useComposable();
const { mrnas } = refs;
const { confirm, preview, model } = nodes;
const { view } = computeds;

defineExpose({ init: methods.init });
onMounted(() => {
    if (route.query.uuid) return;
    else {
        methods.init({ id: data.id });
    }
});
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>
